module.exports = __webpack_public_path__ + "img/fuji.7e92c11d.svg";